import React, { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import LandingPage from "./pages/LandingPage";
import HomePage from "./pages/HomePage";
import BookingPage from "./pages/BookingPage";
import BookingSuccess from "./pages/BookingSuccess";
import BookingCancel from "./pages/BookingCancel";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminResetPassword from "./pages/AdminResetPassword";
import CleaningHomePage from "./pages/CleaningHomePage";
import CleaningBookingPage from "./pages/CleaningBookingPage";
import CleaningBookingSuccess from "./pages/CleaningBookingSuccess";
import CleaningBookingCancel from "./pages/CleaningBookingCancel";
import CleaningAdminLogin from "./pages/CleaningAdminLogin";
import CleaningAdminDashboard from "./pages/CleaningAdminDashboard";
import CleaningResetPassword from "./pages/CleaningResetPassword";
import CleaningInvoiceDetail from "./pages/CleaningInvoiceDetail";
import PlatinumBookingPage from "./pages/platinum/PlatinumBookingPage";
import FAQPage from "./pages/FAQPage";
import PowerWashingContact from "./pages/PowerWashingContact";

import { trackPageView, trackHeartbeat } from "./lib/api";

function PageTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname, document.referrer);
  }, [location.pathname]);
  return null;
}

function SessionTracker() {
  const sessionRef = useRef(null);
  useEffect(() => {
    if (!sessionRef.current) {
      sessionRef.current = `s_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
    }
    trackHeartbeat(sessionRef.current);
    const interval = setInterval(() => {
      trackHeartbeat(sessionRef.current);
    }, 30000);
    return () => clearInterval(interval);
  }, []);
  return null;
}

function App() {
  return (
    <div className="App min-h-screen bg-white">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <PageTracker />
        <SessionTracker />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/transport" element={<HomePage />} />
          <Route path="/booking" element={<BookingPage />} />
          <Route path="/booking/success" element={<BookingSuccess />} />
          <Route path="/booking/cancel" element={<BookingCancel />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/reset-password" element={<AdminResetPassword />} />
          <Route path="/cleaning" element={<CleaningHomePage />} />
          <Route path="/cleaning/booking" element={<CleaningBookingPage />} />
          <Route path="/cleaning/booking/success" element={<CleaningBookingSuccess />} />
          <Route path="/power-washing" element={<PowerWashingContact />} />

          <Route path="/cleaning/booking/cancel" element={<CleaningBookingCancel />} />
          <Route path="/cleaning/admin" element={<CleaningAdminLogin />} />
          <Route path="/cleaning/admin/dashboard" element={<CleaningAdminDashboard />} />
          <Route path="/cleaning/invoices/:invoiceId" element={<CleaningInvoiceDetail />} />
          <Route path="/platinum" element={<PlatinumBookingPage />} />
          <Route path="/cleaning/admin/reset-password" element={<CleaningResetPassword />} />
          <Route path="/faq" element={<FAQPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
